import React, { useEffect, useRef, useState } from 'react';
import { Device } from 'mediasoup-client';
import io from 'socket.io-client';
import streamSignals from '../hooks/useStreamSignals';

const StreamViewer = ({ streamId, clearStream  }) => {
  const socketUrl = process.env.REACT_APP_STREAM_MEDIASOUP_URL;

  const videoRef = useRef(null);
  const socketRef = useRef(null);
  const consumerRef = useRef(null);
  const transportRef = useRef(null);
  const [streamEnded, setStreamEnded] = useState(false);

  useEffect(() => {
    const onError = () => {
      setStreamEnded(true);
    };

    videoRef.current.addEventListener('error', onError);

    const connectToStream = async () => {
      try {
        const socket = io(socketUrl);
        socketRef.current = socket;

        const emitAsync = (event, data = null) =>
          new Promise((resolve, reject) => {
            socket.emit(event, data, (res) => {
              if (res?.error) return reject(res.error);
              resolve(res);
            });
          });

        const device = new Device();
        const routerRtpCapabilities = await emitAsync(streamSignals.capabilities);
        await device.load({ routerRtpCapabilities });

        const transportInfo = await emitAsync(streamSignals.consumer.create);
        const transport = device.createRecvTransport(transportInfo);
        transportRef.current = transport;

        transport.on('connect', ({ dtlsParameters }, callback, errback) => {
          emitAsync(streamSignals.consumer.connect, { dtlsParameters }).then(callback).catch(errback);
        });

        const { id, producerId, kind, rtpParameters } = await emitAsync(streamSignals.consumer.consume, {
          streamId,
          rtpCapabilities: device.rtpCapabilities,
        });

        // console.log(rtpParameters);
        const consumer = await transport.consume({ id, producerId, kind, rtpParameters });
        if (consumer.paused) await consumer.resume();

        console.log('Consumer:', consumer);
        console.log('Track:', consumer.track);

        consumerRef.current = consumer;

        const track = consumer.track;
        console.log('Track kind:', track.kind, 'Track readyState:', track.readyState);
        const stream = new MediaStream([track]);

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            console.log('Metadata loaded');
            videoRef.current.play().catch(err => console.error('Playback error:', err));
          };
          // videoRef.current.play().catch(e => console.error('Video play error:', e));
        }
      } catch (err) {
        console.error('Viewer error:', err);
      }
    };

    connectToStream();

    return () => {
      //Cleanup everything
      if (videoRef.current) {
        videoRef.current.removeEventListener('error', onError);
        videoRef.current.pause();
        videoRef.current.srcObject = null;
      }
      if (transportRef.current){
        transportRef.current.close();
      } 
      if (socketRef.current) {
        socketRef.current.removeAllListeners();
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      if (consumerRef.current) {
        consumerRef.current.close();
        consumerRef.current = null;
      }
    };
  }, [streamId]);

  return (
    <div className="stream-viewer-container">
       {streamEnded ? (
        <div className="stream-ended-message">
          <p>This broadcast has ended.</p>
        </div>
      ) : (
      <video
        ref={videoRef}
        controls
        autoPlay
        muted={true}
        playsInline
        className="stream-video"
      />
      )}
    </div>
  );
};

export default StreamViewer;
